import { Action } from 'redux';

import { isSetLayoutTypeAction } from '../actions/spaces/LayoutTypeAction';
import { LayoutType, WidthToLayoutType } from '../state/LayoutType';

export function layoutTypeReducer(
  previousState: LayoutType = WidthToLayoutType(window.innerWidth),
  action: Action = null
): LayoutType {

  if (isSetLayoutTypeAction(action) && previousState !== action.layoutType) {
    return action.layoutType;
  }

  return previousState;
}
